import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CustomNavbarClients from "../navBarClients/CustomNavbarClients";
import ClientMenuBar from "../ClientMenuBar";
import Footer from "../Footer";
import "./TermsAndConditions.scss";

const TermsAndConditions: React.FC = () => {
  return (
    <>
      <CustomNavbarClients />
      <ClientMenuBar />
      
      <div className="terms-container">
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} lg={10} xl={8}>
              {/* Main Title */}
              <div className="terms-title-section">
                <h1 className="terms-main-title">
                  Términos y Condiciones
                </h1>
                <p className="terms-subtitle">
                  Nallely Boutique - Condiciones de uso y políticas
                </p>
              </div>

              {/* Content */}
              <div className="terms-content">
                {/* Section 1 */}
                <section className="terms-section">
                  <h2 className="section-title">1. Aceptación de Términos</h2>
                  <p className="section-text">
                    Al acceder y utilizar el sitio web de Nallely Boutique, usted acepta estar sujeto a estos términos y condiciones de uso. Si no está de acuerdo con alguno de estos términos, no debe utilizar este sitio web. Nallely Boutique se reserva el derecho de actualizar o modificar estos términos en cualquier momento sin previo aviso.
                  </p>
                </section>

                {/* Section 2 */}
                <section className="terms-section">
                  <h2 className="section-title">2. Descripción del Servicio</h2>
                  <p className="section-text">
                    Nallely Boutique es una tienda de moda y accesorios que ofrece productos de calidad a través de nuestro sitio web y tienda física. Ofrecemos una amplia gama de productos incluyendo ropa, calzado, accesorios y artículos de moda para diferentes gustos y estilos. Nos comprometemos a proporcionar descripciones precisas de nuestros productos, aunque no podemos garantizar que todas las descripciones sean completamente exactas, completas, confiables, actuales o libres de errores.
                  </p>
                </section>

                {/* Section 3 */}
                <section className="terms-section">
                  <h2 className="section-title">3. Registro de Usuario y Cuentas</h2>
                  <p className="section-text">
                    Para realizar compras en nuestro sitio web, es necesario crear una cuenta proporcionando información veraz y actualizada. Usted es responsable de mantener la confidencialidad de su contraseña y de todas las actividades que ocurran bajo su cuenta. Debe notificarnos inmediatamente sobre cualquier uso no autorizado de su cuenta. Nallely Boutique no será responsable de ninguna pérdida o daño derivado del incumplimiento de esta obligación de seguridad.
                  </p>
                </section>

                {/* Section 4 */}
                <section className="terms-section">
                  <h2 className="section-title">4. Productos y Precios</h2>
                  <p className="section-text">
                    Todos los productos mostrados en nuestro sitio web están sujetos a disponibilidad. Los precios de nuestros productos están sujetos a cambio sin previo aviso. Nos reservamos el derecho de modificar o descontinuar productos en cualquier momento. En caso de error en el precio de un producto, nos reservamos el derecho de cancelar cualquier pedido realizado con ese precio incorrecto, incluso si el pedido ha sido confirmado y se ha cobrado su tarjeta de crédito.
                  </p>
                </section>

                {/* Section 5 */}
                <section className="terms-section">
                  <h2 className="section-title">5. Proceso de Compra y Pago</h2>
                  <p className="section-text">
                    Al realizar un pedido, usted se compromete a proporcionar información de compra y cuenta actual, completa y precisa. Todos los pedidos están sujetos a aceptación y disponibilidad. Aceptamos varios métodos de pago incluyendo tarjetas de crédito, débito, PayPal, transferencias bancarias y pagos en efectivo en tiendas de conveniencia como OXXO. El procesamiento del pago se realizará al momento de la compra o al envío del producto, según el método de pago seleccionado.
                  </p>
                </section>

                {/* Section 6 */}
                <section className="terms-section">
                  <h2 className="section-title">6. Envíos y Entregas</h2>
                  <p className="section-text">
                    Ofrecemos servicio de envío a toda la República Mexicana. Los tiempos de entrega pueden variar según la ubicación geográfica y están sujetos a la disponibilidad del servicio de mensajería. Los costos de envío se calcularán según el destino y el peso del paquete. Nallely Boutique no se hace responsable por retrasos en la entrega causados por el servicio de mensajería, condiciones climáticas adversas, o circunstancias fuera de nuestro control.
                  </p>
                  <p className="section-text">
                    <strong>IMPORTANTE:</strong> Una vez que el producto sea entregado exitosamente en la dirección proporcionada, la responsabilidad de Nallely Boutique termina completamente. No se aceptarán reclamos por productos que no cumplan con las expectativas del cliente después de la entrega, ya que todas las ventas son finales y sin posibilidad de devolución o cambio.
                  </p>
                </section>

                {/* Section 7 */}
                <section className="terms-section">
                  <h2 className="section-title">7. Política de Ventas - Sin Devoluciones ni Cambios</h2>
                  <p className="section-text">
                    <strong>TODAS LAS VENTAS SON FINALES.</strong> Nallely Boutique NO acepta devoluciones, cambios, ni reembolsos de ningún tipo una vez completada la compra. Esta política aplica a todos nuestros productos sin excepción, incluyendo pero no limitado a: ropa, calzado, accesorios, productos en oferta, artículos con descuento, y productos personalizados.
                  </p>
                  <p className="section-text">
                    Le recomendamos encarecidamente que revise cuidadosamente las tallas, colores, descripciones y especificaciones de los productos antes de realizar su compra. Si tiene dudas sobre algún producto, puede contactarnos antes de realizar la compra a través de nuestros canales de atención al cliente. Una vez confirmado el pedido y procesado el pago, la venta será definitiva e irreversible.
                  </p>
                  <p className="section-text">
                    Esta política de no devoluciones es aplicable tanto para compras realizadas en línea como en nuestra tienda física. Al realizar una compra, el cliente acepta expresamente esta condición y renuncia a cualquier derecho de devolución o cambio que pudiera corresponderle bajo otras circunstancias.
                  </p>
                </section>

                {/* Section 8 */}
                <section className="terms-section">
                  <h2 className="section-title">8. Propiedad Intelectual</h2>
                  <p className="section-text">
                    Todo el contenido de este sitio web, incluyendo pero no limitado a textos, gráficos, logotipos, iconos, imágenes, clips de audio, descargas digitales y compilaciones de datos, es propiedad de Nallely Boutique o de sus proveedores de contenido y está protegido por las leyes mexicanas e internacionales de derechos de autor. Está prohibida la reproducción, distribución, modificación o uso comercial del contenido sin autorización expresa por escrito.
                  </p>
                </section>

                {/* Section 9 */}
                <section className="terms-section">
                  <h2 className="section-title">9. Privacidad y Protección de Datos</h2>
                  <p className="section-text">
                    La privacidad de nuestros clientes es importante para nosotros. Recopilamos y utilizamos información personal de acuerdo con nuestra Política de Privacidad. Al utilizar nuestro sitio web, usted consiente la recopilación y uso de su información de acuerdo con nuestra política. Implementamos medidas de seguridad para proteger su información personal, aunque no podemos garantizar la seguridad absoluta de los datos transmitidos por internet.
                  </p>
                </section>

                {/* Section 10 */}
                <section className="terms-section">
                  <h2 className="section-title">10. Limitación de Responsabilidad</h2>
                  <p className="section-text">
                    Nallely Boutique no será responsable de ningún daño directo, indirecto, incidental, especial o consecuente que resulte del uso o la incapacidad de usar nuestro sitio web o productos, incluso si hemos sido advertidos de la posibilidad de tales daños. Nuestra responsabilidad total hacia usted por cualquier causa no excederá el monto pagado por usted por el producto o servicio en cuestión.
                  </p>
                </section>

                {/* Section 11 */}
                <section className="terms-section">
                  <h2 className="section-title">11. Modificaciones del Servicio</h2>
                  <p className="section-text">
                    Nallely Boutique se reserva el derecho de modificar o descontinuar, temporal o permanentemente, el servicio o cualquier parte del mismo con o sin previo aviso. No seremos responsables ante usted o terceros por cualquier modificación, suspensión o descontinuación del servicio. Estas modificaciones pueden incluir cambios en la funcionalidad, interfaz del usuario, políticas de precios, o disponibilidad de productos.
                  </p>
                </section>

                {/* Section 12 */}
                <section className="terms-section">
                  <h2 className="section-title">12. Ley Aplicable y Jurisdicción</h2>
                  <p className="section-text">
                    Estos términos y condiciones se regirán e interpretarán de acuerdo con las leyes de México. Cualquier disputa que surja de o esté relacionada con estos términos será resuelta por los tribunales competentes de Heroica Matamoros, Tamaulipas, México. Al utilizar este sitio web, usted acepta someterse a la jurisdicción personal de dichos tribunales.
                  </p>
                </section>

                {/* Section 13 */}
                <section className="terms-section">
                  <h2 className="section-title">13. Contacto</h2>
                  <p className="section-text">
                    Si tiene alguna pregunta sobre estos términos y condiciones, puede contactarnos a través de los siguientes medios:
                  </p>
                  <ul className="contact-list">
                    <li><strong>Correo electrónico:</strong> boutique_marte@hotmail.com</li>
                    <li><strong>Teléfono:</strong> 868 265 3942</li>
                    <li><strong>Dirección:</strong> Av Marte R. Gómez 403, Francisco I. Madero, 87395 Heroica Matamoros, Tamps.</li>
                    <li><strong>Horario de atención:</strong> Lunes a Sábado de 10:00 a.m. a 7:00 p.m.</li>
                  </ul>
                </section>

                {/* Footer info */}
                <div className="terms-footer">
                  <p className="last-updated">
                    <strong>Última actualización:</strong> Julio 2025
                  </p>
                  <p className="effective-date">
                    Estos términos y condiciones son efectivos a partir de la fecha de su publicación y se mantendrán en vigor hasta que sean modificados o reemplazados.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      
      <Footer />
    </>
  );
};

export default TermsAndConditions;